import { MenuItem, Select } from '@material-ui/core';
import { Button } from '@material-ui/core';

import Container from 'mango-ui/layout/Container';
import * as React from 'react';
import { IRegion } from '../api/operation/region';
const style = require('./RegionInfoView/style.less');

export interface IRegionListProps {
  regions: IRegion[];
  selectedRegion: IRegion;
  onRegionSelected: (region: string) => void;
  editing: boolean;
  onToggleEditing: IFunction;
  onCancelEditing: IFunction;
}

const styles = (theme: any) => ({
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

export const SelectRegion = ({ regions, selectedRegion, onRegionSelected }: IRegionListProps) => {
  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: 10, whiteSpace: 'nowrap' }}>选择大区:</span>
      <Select
        autoWidth
        value={selectedRegion && selectedRegion._id || '未选择'}
        onChange={e => onRegionSelected(e.target.value)}
        className={'classes.selectEmpty'}
      >
        <MenuItem value="未选择">未选择</MenuItem>
        {regions.map(region => {
          return (
            <MenuItem
              key={region._id}
              value={region._id}
            >
              {region.name}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

export const EditRegionButton = ({ regions, selectedRegion, onRegionSelected, editing, onToggleEditing, onCancelEditing }: IRegionListProps) => {
  return (
    <div>
      <div>
        {!selectedRegion ? '请先选择大区' : `当前选择${selectedRegion.name}`}&nbsp;
        {editing ? <Button
          variant="outlined"
          onClick={onCancelEditing}
        >
          撤销修改
        </Button> : null}
      </div>
      <Button
        disabled={!selectedRegion}
        variant="outlined"
        onClick={onToggleEditing}
      >
        {editing ? '提交' : '编辑'}
      </Button>
    </div>
  );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/RegionListView.tsx